/* eslint-disable camelcase */
/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
import React from 'react'
import { graphql } from 'gatsby'

// Components
import SEO from 'components/SEO'
import Layout from 'components/shared/Layout'
import Hero from 'components/shared/Hero'
import OtherPartners from 'components/shared/OtherPartners'
import ButtonDefault from 'components/elements/ButtonDefault'
import ParseContent from 'components/shared/ParseContent'

// Third Party
import styled from 'styled-components'

const BlogContent = styled.div`
  h3 {
    font-size: ${props => props.theme.font.size.xm};
    font-weight: ${props => props.theme.font.weight.xl};
    padding-top: 40px;
  }
`

const Story = styled(ParseContent)`
  p {
    font-size: ${props => props.theme.font.size.sm};
    color: ${props => props.theme.color.text.dark};
    line-height: 30px;
  }

  li {
    font-size: ${props => props.theme.font.size.sm};
    color: ${props => props.theme.color.text.dark};
    line-height: 30px;
  }
`

const ContactLink = styled.div``

export const pageQuery = graphql`
  query($wordpress_id: Int) {
    page: wordpressWpPartner(wordpress_id: { eq: $wordpress_id }) {
      ...SinglePartnerFrag
    }
  }
`

const PageTemplate = ({
  data: {
    page: { path, acf, wordpress_id, title, yoast_meta: yoast },
  },
}) => {
  return (
    <Layout>
      <SEO
        yoast={yoast}
        path={path}
        image={{ url: acf.content.image.localFile && acf.content.image.localFile.childImageSharp.openGraph.src }}
      />

      <Hero className="mb-lg-3" article backUrl="/partners-en-oplossingen/" title={title} content={acf.content} />

      <div className="container pb-5">
        <div className="row">
          <BlogContent className="col-lg-7 pr-5">
            <Story content={acf.content.story} className="py-5" />
            <ContactLink className="py-5 d-flex justify-content-center align-items-center">
              <p className="mb-0 mr-4 font-size-xm font-weight-xl">Meer weten over ons?</p>
              <ButtonDefault icon="arrow" to="/contact">
                <p>Neem contact op</p>
              </ButtonDefault>
            </ContactLink>
          </BlogContent>
          <div className="col-lg-5 pt-lg-5">
            <OtherPartners wpId={wordpress_id} />
          </div>
        </div>
      </div>

    </Layout>
  )
}

export default PageTemplate
